'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

class Signup {
  getCurrencies() {
    return index.adapter.signup.getCurrencies();
  }
  registrationTypes() {
    return index.adapter.signup.registrationTypes();
  }
  getRegDDLists() {
    return index.adapter.signup.getRegDDLists();
  }
  checkEmail(params) {
    return index.adapter.signup.checkEmail(params);
  }
  getOccupations(lang) {
    const params = { lang };
    return index.adapter.signup.getOccupations(params);
  }
  getOccupationsByRegulation(regulatorAcronym) {
    const params = { regulatorAcronym };
    return index.adapter.signup.getOccupationsByRegulation(params);
  }
  getNationalities() {
    return index.adapter.signup.getNationalities();
  }
  checkUsername(params) {
    return index.adapter.signup.checkUsername(params);
  }
  getSubdivisions(params) {
    return index.adapter.signup.getSubdivisions(params);
  }
  getIndustries() {
    return index.adapter.signup.getIndustries();
  }
  addressFinder(params) {
    return index.adapter.signup.addressFinder(params);
  }
  addressFinderMetadata(params) {
    return index.adapter.signup.addressFinderMetadata(params);
  }
  getPepSourceOfWealth() {
    return index.adapter.signup.getPepSourceOfWealth();
  }
  getPepSourceOfFunds() {
    return index.adapter.signup.getPepSourceOfFunds();
  }
  getPepCategories() {
    return index.adapter.signup.getPepCategories();
  }
}
const signup = new Signup();

exports.signup = signup;
